import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext({ settings: {}, products: [], faqs: [], loading: true, refresh: () => {} });

export function SiteProvider({ children }) {
  const [data, setData] = useState({ settings: {}, products: [], faqs: [], loading: true });

  const load = useCallback(async () => {
    try {
      const res = await api.get("/site");
      setData({ ...res.data, loading: false });
    } catch (e) {
      setData((d) => ({ ...d, loading: false }));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <SiteContext.Provider value={{ ...data, refresh: load }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
